module.exports = __webpack_public_path__ + "img/logo_main.34b2cdb8.svg";